import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  availableStatuses: null,
  registryRights: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      {
        key: "[ma].entryName",
        name: "global:printerModel.manufacturer",
      },
      { key: "modelName", name: "global:printerModel.modelName" },
      { key: "[dt].entryName", name: "global:printerModel.deviceType" },
      { key: "[sp].name", name: "global:printerModel.servicePrice" },
    ],
    selectedSearchFields: [
      "[ma].entryName",
      "modelName",
      "[dt].entryName",
      "[sp].name",
    ],
    dictionaryFields: ["deviceType", "manufacturer", "options"],
    url: "printermodel",
  },
};

const printerModelReducer = createSlice({
  name: "printerModelReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = printerModelReducer.actions;

export default printerModelReducer.reducer;
